module.exports = __webpack_public_path__ + "assets/bf-se.0b029278.svg";